import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DevicesComponent } from './devices.component';
import { SharedModule } from '../../shared/shared.module';
import { DeviceTabComponent } from './device-tab/device-tab.component';
import { SortablejsModule } from 'angular-sortablejs/dist';
import { LoadingModule } from 'ngx-loading';
import { MatSelectModule, MatSlider, MatSliderModule } from '@angular/material';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DeviceDetailComponent } from './device-detail/device-detail.component';
import { SchedulingDeviceComponent } from '../scheduling/scheduling-device/scheduling-device.component';
import { RouterModule } from '@angular/router';
import { FullCalendarModule } from 'ng-fullcalendar';
import { ChartsModule } from 'ng2-charts';
import { OwlDateTimeModule, OwlNativeDateTimeModule, OwlDateTimeIntl } from 'ng-pick-datetime';
import { FormsModule } from '@angular/forms';
import { DefaultIntl } from './defaultIntl';
import { DatePipeProxy } from '../../shared/translate/datePipeProxy.component';
import { DeviceCardComponent } from './device-tab/device-card/device-card.component';
import { ClimatizationDetailComponent } from './device-detail/climatization-detail/climatization-detail.component';
import { TemperatureDetailComponent } from './device-detail/climatization-detail/temperature-detail/temperature-detail.component';
import { ThermostatDetailComponent } from './device-detail/climatization-detail/thermostat-detail/thermostat-detail.component';
import { SensorDetailComponent } from './device-detail/sensor-detail/sensor-detail.component';
import { ConsumptionDetailComponent } from './device-detail/consumption-detail/consumption-detail.component';
import { GenerationDetailComponent } from './device-detail/generation-detail/generation-detail.component';
import { AirconditioningDetailComponent } from './device-detail/climatization-detail/airconditioning-detail/airconditioning-detail.component';
import { IotService } from '../../core/services/iot.service';
import {MatTooltipModule} from '@angular/material/tooltip';
@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    SharedModule,
    SortablejsModule,
    LoadingModule,
    MatSelectModule,
    BrowserAnimationsModule,
    FullCalendarModule,
    ChartsModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    FormsModule,
    MatSliderModule,
    MatTooltipModule
  ],
  providers: [
    {provide: OwlDateTimeIntl, useClass: DefaultIntl},
    DatePipeProxy,
    IotService
  ],
  declarations: [
    DevicesComponent,
    DeviceTabComponent,
    DeviceDetailComponent,
    SchedulingDeviceComponent,
    DeviceCardComponent,
    ClimatizationDetailComponent,
    TemperatureDetailComponent,
    ThermostatDetailComponent,
    AirconditioningDetailComponent,
    SensorDetailComponent,
    ConsumptionDetailComponent,
    GenerationDetailComponent
  ]
})
export class DevicesModule { }



// WEBPACK FOOTER //
// ./src/app/entities/devices/devices.module.ts